const textColor = "#ffffff";
const backgroundColor = "#182848";

export const fallbackValues = {
  textColor,
  backgroundColor
};
